import React from "react";
import "./ModernOptionCard.css";

const ModernOptionCard = ({
  title,
  subtitle,
  icon,
  children,
  className = "",
  isActive = false,
}) => {
  return (
    <div
      className={`modern-option-card ${className} ${isActive ? "active" : ""}`}
    >
      <div className="card-header">
        {icon && (
          <div
            className="card-icon"
            style={{ color: "var(--primary-background-darker)" }}
          >
            {icon}
          </div>
        )}
        <div className="card-title-section">
          <h3 className="card-title">{title}</h3>
          <p className="card-subtitle">{subtitle}</p>
        </div>
      </div>
      <div className="card-content">{children}</div>
    </div>
  );
};

export default ModernOptionCard;
